import api from "./api.service";
import { adminTokenService } from "./admin.token.service";

export interface DispatcherVehicle {
    id: number;
    idDispatcher: number;
    name: string;
    description?: string;
    status: number; // 0: Inactive, 1: Active, 2: Deleted
}

export interface GetDispatcherVehiclesParams {
    idDispatcher?: number;
    page?: number;
    pageSize?: number;
    status?: number;
    SearchString?: string;
}

export interface GetDispatcherVehiclesResponse {
    statusCode: number;
    message: string;
    data: DispatcherVehicle[];
    pagination: {
        totalCount: number;
        page: number;
        pageSize: number;
        totalPages: number;
    };
}

export interface CreateDispatcherVehicleData {
    idDispatcher: number;
    name: string;
    description?: string;
    status: number;
}

export interface UpdateDispatcherVehicleData {
    id: number;
    idDispatcher: number;
    name: string;
    description?: string;
    status: number;
}

export interface UpdateDispatcherVehicleStatusData {
    id: number;
    status: number;
}

export interface DeleteDispatcherVehicleData {
    id: number;
}

class AdminDispatcherVehicleService {
    private getHeaders() {
        const token = adminTokenService.getAdminToken();
        return {
            Authorization: `${token}`,
        };
    }

    async getDispatcherVehicles(params?: GetDispatcherVehiclesParams): Promise<GetDispatcherVehiclesResponse> {
        try {
            const response = await api.get<GetDispatcherVehiclesResponse>(
                "/admin/get-dispatcher-vehicles",
                {
                    params,
                    headers: this.getHeaders(),
                }
            );
            return response.data;
        } catch (error) {
            console.error("Error fetching admin dispatcher vehicles:", error);
            throw error;
        }
    }

    async getDispatcherVehicleById(id: number): Promise<{ statusCode: number; message: string; data: DispatcherVehicle }> {
        try {
            const response = await api.get<{ statusCode: number; message: string; data: DispatcherVehicle }>(
                `/admin/get-dispatcher-vehicle/${id}`,
                {
                    headers: this.getHeaders(),
                }
            );
            return response.data;
        } catch (error) {
            console.error(`Error fetching admin dispatcher vehicle ${id}:`, error);
            throw error;
        }
    }

    async createDispatcherVehicle(data: CreateDispatcherVehicleData): Promise<any> {
        try {
            const response = await api.post(
                "/admin/create-dispatcher-vehicle",
                data,
                {
                    headers: this.getHeaders(),
                }
            );
            return response.data;
        } catch (error) {
            console.error("Error creating admin dispatcher vehicle:", error);
            throw error;
        }
    }

    async updateDispatcherVehicle(data: UpdateDispatcherVehicleData): Promise<any> {
        try {
            const response = await api.post(
                "/admin/update-dispatcher-vehicle",
                data,
                {
                    headers: this.getHeaders(),
                }
            );
            return response.data;
        } catch (error) {
            console.error("Error updating admin dispatcher vehicle:", error);
            throw error;
        }
    }

    async changeDispatcherVehicleStatus(data: UpdateDispatcherVehicleStatusData): Promise<any> {
        try {
            const response = await api.post(
                "/admin/change-dispatcher-vehicle-status",
                data,
                {
                    headers: this.getHeaders(),
                }
            );
            return response.data;
        } catch (error) {
            console.error("Error changing admin dispatcher vehicle status:", error);
            throw error;
        }
    }

    async deleteDispatcherVehicle(data: DeleteDispatcherVehicleData): Promise<any> {
        try {
            const response = await api.post(
                "/admin/delete-dispatcher-vehicle",
                data,
                {
                    headers: this.getHeaders(),
                }
            );
            return response.data;
        } catch (error) {
            console.error("Error deleting admin dispatcher vehicle:", error);
            throw error;
        }
    }
}

export const adminDispatcherVehicleService = new AdminDispatcherVehicleService();
